import { render, staticRenderFns } from "./FeDiosaTextil.vue?vue&type=template&id=dd11ae5a&"
import script from "./FeDiosaTextil.vue?vue&type=script&lang=js&"
export * from "./FeDiosaTextil.vue?vue&type=script&lang=js&"
import style0 from "./FeDiosaTextil.vue?vue&type=style&index=0&id=dd11ae5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports